﻿import radioButton from '@components/radioButton';
import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectBathrooms } from '../redux/selectors';
import { searchParametersSlice } from '../redux/slices';

export default class Bathroom {
  constructor(bathroomGroup) {
    this.bathroomGroup = bathroomGroup;
    const bathroomsRadio$ = radioButton(this.bathroomGroup);
    bathroomsRadio$.subscribe((value) => store.dispatch(searchParametersSlice.actions.fetchBathrooms(value)));
    store$.pipe(map(selectBathrooms), distinctUntilChanged()).subscribe(this.updateValue.bind(this));
  }

  updateValue(value) {
    const bathrooms = value || 0;
    const previousValue = this.bathroomGroup.querySelector('input:checked');
    const newValue = this.bathroomGroup.querySelector(`[value="${bathrooms}"]`);
    if (previousValue) {
      previousValue.checked = false;
    }
    newValue.checked = true;
  }
}
